import React from 'react';
import IndexRow from './IndexRow';
import { worksItems } from '../constants/data';

export default function WorksSection() {
  return (
    <section id="work" className="flex flex-col gap-[18px] items-start w-full">
      <div className="flex items-center px-4 sm:px-8 w-full">
        <span className="font-trispace type-section-label text-black flex-1">INDEXED WORKS</span>
      </div>
      <div className="flex flex-col items-start w-full">
        {worksItems.map((item) => (
          <IndexRow
            key={item.index}
            category={item.category}
            index={item.index}
            name={item.name}
            theme={item.theme}
            href={item.href}
            target={item.target}
            className={item.href ? 'menu-row works-link-row selected' : undefined}
          />
        ))}
      </div>
    </section>
  );
}
